import Axios from 'axios';
import { Url } from '../general/modules/url';
import { GetLinkedAccountsInfoResponse } from '../accounts/tethers-types';
import { GetConsentStateResponse } from '../marketing/ConsentState';


export async function requestAccountWindow(
    suid: string,
    linkedAccountsInfo: GetLinkedAccountsInfoResponse,
    consentState: GetConsentStateResponse
): Promise<string> {
    const response = await Axios.post<string>(Url.getNoLangUrl('api/renderAccountView'), {
        suid,
        linkedAccountsInfo,
        consentState
    });

    return response.data;
}
